// Alpine's x-teleport clones template content into the teleport target (e.g. <body>).
// Turbo caches the live DOM on navigation and captures those clones detached from their
// x-data scope; on back/forward restore Alpine re-initialises the orphaned clone and
// throws (e.g. "opened is not defined"), leaving broken/duplicate modals. Remove Alpine's
// teleported clones before Turbo snapshots the page so the cache stays clean — Alpine
// re-teleports fresh copies when the restored page initialises.
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll("template[x-teleport]").forEach((template) => {
    template._x_teleport?.remove()
  })
})
